
/*
akhila    10/28/2022 3075154998 enable framework UX changes
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Ashraf 01/02/2022 3075154998 renamed usage header title

*/

import React, {useEffect, useContext} from 'react';
import capitalize from '../../../../../util/Capitalize';
import {useSelector, useDispatch} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {resetFilterUsagedata} from '../../../../../redux/reducers/EnableFramework/Filter';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {Button} from '@material-ui/core';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {ArrowBack} from '@material-ui/icons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import {modulesText} from '../../../../../util/Content';

export default function FilterUsage({setValueCode}) {
  const {isLoading, successMsg, errorMsg, usageFilter} = useSelector(({filter}) => filter);
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  useEffect(() => {
    return () => {
      dispatch(resetFilterUsagedata());
    };
  }, []);
  const object = usageFilter?.placeResponse ? usageFilter?.placeResponse : {};


  const values = [];
  object &&
    Object.entries(object)?.forEach(([key, value]) => {
      value?.codes?.length > 0 &&
        value?.codes?.forEach((el, i) => {
          values.push({
            frameWork: key,
            codes: el,
            description: value?.description?.[i] ?? '-',
          });
        });
    });

  const columns = [
    {
      title: modulesText,
      field: 'frameWork',
      render: (rowData) => {
        return rowData?.frameWork ? capitalize(rowData?.frameWork) : '--';
      },
    },
    {
      title: 'Code',
      field: 'codes',
      render: (rowData) => {
        return rowData?.codes ? rowData?.codes : '--';
      },
    },
    {
      title: 'Description',
      field: 'description',
      render: (rowData) => {
        return rowData?.description ? rowData?.description : '--';
      },
    },
  ];
  return (
    <div>
      <div className="button-table-spacing-mb justify-content-start">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn mx-1`}
          onClick={() => {
            setValueCode(0);
          }}
        >
          <ArrowBack className="mr-2" />
           Search Filter
        </Button>
      </div>
      <div className={`mb-0 ${classes.tabCardStyles}`}>
        <div className="custom-table">
          <GuiTable
            title={
              'This Filter has been used in the following frameworks.'
            }
            columns={columns}
            data={values}
            textAlign="left"
            actions={[
              {
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="contained"
                      className={`mx-1 themeing-buttons ${classes.buttonRoot}`}
                      color="primary"
                    >
                      Print Usage
                    </Button>
                  </>
                ),
                tooltip: 'Print Usage',
                isFreeAction: true,
                onClick: (event) => {},
              },
            ]}
            options={{
              paging: true,
              toolbar: true,
              search: true,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
              pageSize: defaultRows,
              pageSizeOptions: tablePageRows,
            }}
          />
        </div>
      </div>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
}
